if($('.btn-custom').length){
  $('.btn-custom').removeClass('btn-custom').addClass('btn btn--primary theme-icon-arrow').removeAttr('style').prepend('<span><i class="icon icon-arrow-right"></i></span>');
}

if($('.btn-custom-previous').length){
  $('.btn-custom-previous').removeClass('btn-custom-previous').addClass('btn btn--secondary theme-icon-arrow text-decoration-none').removeAttr('style').prepend('<span><i class="icon icon-arrow-left"></i></span>');
}

if($('input.btn.btn-success.btn-lg').length){
  $('input.btn.btn-success.btn-lg').removeClass('btn-success').addClass('btn--primary text-decoration-none').removeAttr('style');
}
